// The front page's first screen: the slogan, marked in red pen, what we are, and the live log.
import { ArrowRight } from "@phosphor-icons/react";
import { Link } from "react-router";

import { RedPen } from "../../ui/RedPen";
import { OversightLog } from "./OversightLog";

export function Hero() {
  return (
    <section className="grain relative overflow-hidden border-b border-line">
      <div className="rule-dots pointer-events-none absolute inset-y-0 end-0 hidden w-1/3 opacity-60 [mask-image:linear-gradient(to_left,black,transparent)] lg:block" aria-hidden />
      <div className="wrap relative grid gap-12 pb-16 pt-12 sm:pt-20 lg:grid-cols-[1.25fr_1fr] lg:items-center lg:gap-16 lg:pb-24">
        <div>
          <p className="kicker animate-rise">A community for accountable AI</p>
          <h1 className="display mt-5 animate-rise text-[3.1rem] sm:text-[4.6rem] xl:text-[5.6rem]">
            You can't trust AI companies to mark their own <RedPen kind="circle" delay={0.6}>homework.</RedPen>
          </h1>
          <p className="lede mt-7 max-w-xl animate-rise [animation-delay:150ms]">
            So we mark it together. OpenCloudSecurity teaches people and organisations to secure their access in the age of AI, gives away the tools to do it, and
            pushes AI companies to meet standards the public sets.
          </p>
          <div className="mt-9 flex flex-wrap items-center gap-3 animate-rise [animation-delay:250ms]">
            <Link to="/charter#sign" className="btn-signal">
              Sign the Charter <ArrowRight weight="bold" className="h-4 w-4" />
            </Link>
            <Link to="/workflows" className="btn-line">
              Browse workflows
            </Link>
          </div>
        </div>
        <div className="animate-rise [animation-delay:300ms]">
          <OversightLog />
          <p className="mt-3 font-mono text-[11px] text-ink3">Every agent action, classed and decided before it happens. That's the bar.</p>
        </div>
      </div>
    </section>
  );
}

const CLAIMS = ["Agents act in your name", "You can't see the meter", "Vendors hold the keys", "No one marks their own homework", "Workflows should be portable", "People evolve with the work"];

export function Marquee() {
  const run = [...CLAIMS, ...CLAIMS];
  return (
    <div className="overflow-hidden border-b border-ink bg-ink py-3 text-paper" aria-hidden>
      <div className="flex w-max animate-marquee gap-8 whitespace-nowrap font-display text-lg font-bold uppercase tracking-tight">
        {run.map((c, i) => (
          <span key={i} className="flex items-center gap-8">
            {c} <span className="text-signal">✕</span>
          </span>
        ))}
      </div>
    </div>
  );
}
